<script>
    export default {
        props : ['vendors'],
        data(){
            return {

            }
        }
    }
</script>

<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th>Vendor List</th>                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="(v,vi) in vendors" :key="vi">
                    <td>{{ v.name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<style>
    
</style>